// Env var schema, split into two groups:
// - `settings`: non-secret config (URLs, domains) — safe to commit in .env* files.
// - `secrets`: keys, tokens, licences — must never be committed; live in config/secrets.enc.
// `optional` must mean "provably absent in a named environment", never "wasn't sure".

const required = { required: true }
const optional = { required: false }

// Non-secret config: URLs and domains. Safe to commit in .env* files.
const settings = {
  VITE_IRWIN_BASE_URL: required,
  VITE_IRWIN_APP_URL: required,
  VITE_FACTSET_OIDC_AUTHORITY: required,
  VITE_KONG_LIMA_BASE_URL: required,
  VITE_FEATURE_FLAGS_BASE_URL: optional, // only in .env.development; other modes fall back to irwin.baseUrl
  VITE_VERSION: optional, // read by rollbar.js but set in no env file and no CI job today
}

// Secrets and identifiers: keys, tokens, licences.
const secrets = {
  VITE_FACTSET_OIDC_CLIENT_ID: required,
  VITE_FEATURE_FLAGS_KEY: required,
  VITE_MUI_DATAGRID_KEY: required,
  VITE_GEOPLACES_API_KEY: optional, // absent locally and in the CI test job; build jobs get it from the geoplaces-key:* dotenv artifact
  VITE_GMAPS_KEY: optional, // unused by src/; declared only so check-env can reject it from tracked .env
}

export const envSchema = { ...settings, ...secrets }
export const settingKeys = Object.keys(settings)
